import React from "react"
import {Trans} from "react-i18next"

import {Badge} from "../../../../../components/Badge.tsx"
import {AActivityFeed, AProspectActivity} from "../../../../../services/types.generated.ts"
import {commonTransComponents} from "../../../../../utils/i18n.tsx"
import {getOrganizationName} from "../utils.ts"

export const ActivityBodyWon: React.FC<{activity: AActivityFeed | AProspectActivity}> = ({activity}) => {
  return (
    <div>
      <Trans
        i18nKey={"SellingDetails_News_ActivityFeed_Won"}
        components={{...commonTransComponents, badge: <Badge color={"blue"} />}}
        values={{
          organization: getOrganizationName(activity),
        }}
      />
    </div>
  )
}
